
import React from "react";
import "./Premier.css";

import {
  FaCheck,
  FaArrowRight,
  FaGoogle,
  FaShieldAlt,
  FaChartLine,
} from "react-icons/fa";

import GooglePremier from "../../assets/GooglePremier.jpeg";

const PremierPartner = () => {
  const benefits = [
    "Direct Google Strategist Support",
    "Early Access to Google Beta Features",
    "Fast-Track LSA Verification",
    "Certified Search & Display Specialists",
  ];

  return (
    <section className="partner-section">

      <div className="partner-glow"></div>

      <div className="partner-container">

        {/* =================================
            LEFT SIDE
        ================================= */}

        <div className="partner-visual">

          <div className="partner-card">

            {/* GOOGLE PREMIER BADGE */}

            <div className="badge-wrapper">

              <div className="badge-glow"></div>

              <img
                src={GooglePremier}
                alt="Google Premier Partner Badge"
                className="partner-badge"
              />

            </div>


            {/* =================================
                VERIFY GOOGLE PARTNERSHIP
            ================================= */}

            <a
              href="https://www.google.com/partners/agency?id=3697308998"
              target="_blank"
              rel="noopener noreferrer"
              className="verify-partner-button"
            >

              <div className="verify-icon">
                <FaShieldAlt />
              </div>

              <div className="verify-text">
                <strong>Verify Google Partnership</strong>
                <span>View verified agency credentials</span>
              </div>

              <FaArrowRight className="verify-arrow" />

            </a>

          </div>

        </div>


        {/* =================================
            RIGHT SIDE
        ================================= */}

        <div className="partner-content">

          <div className="partner-label">

            <span className="label-icon">
              <FaGoogle />
            </span>

            GOOGLE PREMIER PARTNER

          </div>


          <h2>
            A recognised leader in{" "}
            <span>Google Ads</span>
          </h2>


          <p className="partner-description">
            We are proud to be a Google Premier Partner, recognised for
            our expertise in managing high-performance Google Ads
            campaigns. Our team combines advanced strategy, data-driven
            optimisation, and conversion-focused execution to help
            businesses generate more qualified leads and profitable growth.
          </p>


          {/* BENEFITS */}

          <div className="benefits-grid">

            {benefits.map((benefit, index) => (
              <div
                className="benefit-item"
                key={index}
              >

                <div className="check-icon">
                  <FaCheck />
                </div>

                <span>
                  {benefit}
                </span>

              </div>
            ))}

          </div>


          {/* CTA */}

          <div className="partner-cta">

            <div className="cta-left">

              <div className="cta-chart">
                <FaChartLine />
              </div>

              <div>
                <strong>
                  Ready to scale with Google Ads?
                </strong>

                <span>
                  Get a strategy built around your business goals.
                </span>
              </div>

            </div>


            <a
              href="https://meetings-na2.hubspot.com/adwise-media?uuid=b5338f0a-6ee1-4e2b-88df-ab25699ff81c"
              target="_blank"
              rel="noopener noreferrer"
              className="partner-button"
            >
              Book a Consultation
              <FaArrowRight />
            </a>

          </div>

        </div>

      </div>

    </section>
  );
};

export default PremierPartner;

